import { observer } from 'mobx-react-lite';
import React, { ReactElement } from 'react';
import { questionnaireStepper, QuestionnaireStepperInstance } from '../questionnaire-stepper';

interface QuestionnaireWizardSectionProps {
  render: (stepper: QuestionnaireStepperInstance) => ReactElement;
}

const QuestionnaireWizardSectionImpl: React.FC<QuestionnaireWizardSectionProps> = (props) => {
  const {
    render,
  } = props;

  const stepper = questionnaireStepper.useStepper();

  return render(stepper);
};

export const QuestionnaireWizardSection = observer(QuestionnaireWizardSectionImpl);
